partner-appconfig-recommended-products